module.exports = __webpack_public_path__ + "static/img/inspectOrderlist.d379c6ff.png";